import { apiClient } from '../../../shared/api/axios-instance';
import type { SubscriptionSummary, BillingPeriodResponse } from '../types';

const subscriptionService = {
    /**
     * Get subscription summary statistics
     */
    async getSummary(): Promise<SubscriptionSummary> {
        const response = await apiClient.get('admin/subscriptions/summary');
        return response.data.data || response.data;
    },

    /**
     * Get billing periods with pagination and optional status filter
     */
    async getBillingPeriods(page: number, statusFilter: string | null): Promise<BillingPeriodResponse> {
        const params: Record<string, any> = { page };
        if (statusFilter) {
            params.status = statusFilter;
        }
        
        const response = await apiClient.get('admin/subscriptions/billing-periods', { params });
        return response.data.data || response.data;
    }
};

export default subscriptionService;
